import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from '../../App';
import { BETTER_AUTH_ENABLED } from '../../auth/betterAuthFlag';
import ProviderPickerModal from '../../auth/ProviderPickerModal';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// ['create:users', 'read:users', 'update:users']
const onRedirectCallback = (appState) => {
  // Return to where the user started, else fall back to home.
  const target = appState?.returnTo || '/';
  window.location.replace(target);
};

const Auth0ProviderWithHistory = () => (
  <BrowserRouter>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      // Use explicit callback path that matches Auth0/Kick allowlists
      redirectUri={`${window.location.origin}/login/callback`}
      audience={audience}
      scope="read:users"
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>
);

// Better Auth mode needs no React context provider — the session hook talks
// to /api/auth over the cookie session directly. The provider picker modal
// stands in for the Auth0 hosted login page; post-login redirects are handled
// server-side via callbackURL, so no onRedirectCallback equivalent is needed.
const BetterAuthProviderWithHistory = () => (
  <BrowserRouter>
    <App />
    <ProviderPickerModal />
  </BrowserRouter>
);

export default BETTER_AUTH_ENABLED
  ? BetterAuthProviderWithHistory
  : Auth0ProviderWithHistory;
